module.exports = __webpack_public_path__ + "static/media/icon_134.fa9af4b4.svg";